const asyncMenu = [

]

export default asyncMenu;


// WEBPACK FOOTER //
// ./src/modules/web/router/asyncMenu.js